export default IconBleachNoChlorine => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-bleach-no-chlorine" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75" />
  <path d="M6.576 19l7.907 -13.733" />
  <path d="M11.719 19.014l5.346 -9.284" />
</svg>`;